<div data-cy="generic-upload-picture-modal__page" mat-dialog-title>
    <div class="row">
        <div class="col-md-9 -mt-8">
            <h2 class="dialog-title">Upload photo</h2>
        </div>
        <div class="col-md-3 pull-right">
            <button data-cy="generic-upload-picture-modal__close-btn" type="button" class="close no-margin" (click)="close()" matTooltip="{{ 'close' | transloco | capitaliz }}"><span aria-hidden="true">
                <mat-icon class="d-text-middle">close</mat-icon>
              </span><span class="sr-only">Close</span></button>
        </div>
    </div>
</div>

<div mat-dialog-content>
    <!-- Uploaded files section -->
    <div>
        <h3>Select file</h3>
        <div
            class="uploaded-file gd-auto-horizontal align-center d-cursor-hand"
            *ngIf="!selectedFileName"
            (click)="triggerFileInput()"
            >
            <span>Choose File</span>
        </div>
        <!-- Show selected file -->
        <div
            class="uploaded-file gd-auto-horizontal align-center"
            *ngIf="selectedFileName"
        >
            <span>{{ selectedFileName | trunc:15 }}</span>
            <mat-icon data-cy="generic-upload-picture-modal__remove-file" class="delete-icon" (click)="removeFile()">delete</mat-icon>
        </div>
        
        <input data-cy="generic-upload-picture-modal__file-input"
            type="file"
            id="fileInput"
            accept="image/*"
            (change)="onFileSelected($event)"
            hidden
        />
    </div>

    <!-- Description -->
    <div class="mt-20">
        <h3>Voeg notitie toe</h3>
        <mat-form-field class="full-width" appearance="outline">
        <textarea data-cy="generic-upload-picture-modal__description-input"
            matInput
            placeholder="Bericht"
            rows="3"
            [(ngModel)]="description"
        ></textarea>
        </mat-form-field>
    </div>
</div>

<mat-dialog-actions data-cy="generic-upload-picture-modal__dialog-actions" class="pull-left">
      <button data-cy="generic-upload-picture-modal__on-save-comment-btn" mat-stroked-button [disabled]="!selectedFile || !description?.trim()" (click)="onSaveComment()">{{ 'save' | transloco | capitaliz }}</button>
</mat-dialog-actions>